import { render, staticRenderFns } from "./Afericao.vue?vue&type=template&id=b6b939f4&"
import script from "./Afericao.vue?vue&type=script&lang=js&"
export * from "./Afericao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports